<script setup lang="ts"></script>

<template>
  <div>
    <div
      class="h-100 d-flex flex-column justify-content-center align-items-center bg-light"
    >
      <h3>ERROR 404:</h3>
      <h3>PAGE NOT FOUND</h3>
    </div>
  </div>
</template>

